import { useState } from 'react';
import { getMetric } from '../../constants/metricDefinitions';
import './AnalyticsGuide.css';

/**
 * MetricTooltip — wraps any element and shows a popover with metric definition on hover/click.
 *
 * Props:
 *   metricKey (string)   – key from metricDefinitions.js
 *   children  (node)     – the element to wrap (typically a KPI card)
 *   position  (string)   – 'bottom' | 'top' | 'right' | 'left' (default 'bottom')
 */
export default function MetricTooltip({ metricKey, children, position = 'bottom' }) {
    const [visible, setVisible] = useState(false);
    const metric = getMetric(metricKey);

    if (!metric) return <>{children}</>;

    return (
        <div
            className="metric-tooltip-wrapper"
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {children}
            {visible && (
                <div className={`metric-tooltip-popover metric-tooltip-popover--${position}`} role="tooltip">
                    <div className="metric-tooltip-label">{metric.label}</div>
                    <div className="metric-tooltip-definition">{metric.shortDefinition}</div>
                    {metric.formula && (
                        <div className="metric-tooltip-formula">
                            <span className="metric-tooltip-section-title">Formula</span>
                            <span>{metric.formula}</span>
                        </div>
                    )}
                    {metric.whyItMatters && (
                        <div className="metric-tooltip-why">
                            <span className="metric-tooltip-section-title">Perché conta</span>
                            {metric.whyItMatters}
                        </div>
                    )}
                    {metric.caveat && (
                        <div className="metric-tooltip-caveat">
                            <span className="metric-tooltip-caveat-icon">⚠</span>
                            {metric.caveat}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
